import React, { useContext } from "react";
import RecentJobCard from "../cards/recentJobCard";
import Slider from "../common/Slider";
import { JobContext } from "../../App";
import { Link } from "react-router-dom";
import RecentJobSkeleton from "../pages/skeletons/recentJob";
import Button from "../common/Button";

export const getSliderSettings = ({
  dots,
  arrows,
  slidesToShow,
  removeAutoPlay,
  slidesToShowAt1024Breakpoint,
  slidesToShowAt992Breakpoint,
  objectCount,
  speed,
  autoplaySpeed,
}: any) => {
  const sliderSettings = {
    dots: dots,
    arrows: arrows,
    className: "center",
    infinite: objectCount > slidesToShow ? true : false,
    centerPadding: "160px",
    slidesToShow: slidesToShow,
    swipeToSlide: true,
    autoplay: true,
    speed: speed,
    autoplaySpeed: autoplaySpeed,
    cssEase: "linear",

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slidesToShowAt1024Breakpoint,
          slidesToScroll: 1,
          infinite: objectCount > slidesToShowAt1024Breakpoint ? true : false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: slidesToShowAt992Breakpoint,
          slidesToScroll: 1,
          initialSlide: 1,
          infinite: objectCount > slidesToShowAt992Breakpoint ? true : false,
        },
      },
    ],
  };

  // Conditionally hide some properties
  if (removeAutoPlay) {
    delete sliderSettings.speed;
    delete sliderSettings.autoplaySpeed;
  }

  return sliderSettings;
};

function RecentJobGroup({ filterCategory, currentItem }: any) {
  const { jobs, jobLoading } = useContext(JobContext);

  const safeJobs = Array.isArray(jobs) ? jobs : [];

  // Extract category names from the passed category object
  const categoryNames = Array.isArray(filterCategory)
    ? filterCategory.map((cat: any) => cat?.name).filter(Boolean)
    : [];

  const filteredItems: any[] = categoryNames.length
    ? safeJobs.filter((item: any) => {
        const itemCategories = Array.isArray(item?.category) ? item.category : [];
        return (
          itemCategories.some((cat: any) => categoryNames.includes(cat?.name)) &&
          item?.id !== currentItem
        );
      })
    : safeJobs;

  return (
    <>
      {Array.isArray(filteredItems) && filteredItems.length > 0 && (
        <section className="cht-py-16 sm:cht-py-20 cht-bg-slate-50/50 cht-border-t cht-border-slate-200/80 !cht-font-body">
          <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
            <header className="cht-text-center cht-mb-10 sm:cht-mb-12">
              <span className="cht-inline-flex cht-items-center cht-gap-1.5 cht-px-3.5 cht-py-1.5 cht-rounded-full cht-text-xs cht-font-semibold cht-bg-[#3e57da]/10 cht-text-[#3e57da] cht-mb-3 cht-tracking-wide cht-uppercase">
                Deliverables & Work
              </span>
              <h2 className="cht-text-3xl sm:cht-text-4xl cht-font-bold !cht-font-heading cht-text-[#1e293b] cht-tracking-tight">
                {filterCategory ? "Related Deliverables Completed" : "Featured Deliverables & Case Studies"}
              </h2>
              <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-2.5">
                {filterCategory
                  ? "Explore Related Deliverables & Implementations"
                  : "Explore Our Recent Deliverables & Implementations"}
              </p>
            </header>

            <div className="cht-grid cht-grid-cols-1 sm:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
              {filteredItems.slice(0, 9).map((item: any) => (
                <Link
                  key={item?.id || item?.slug}
                  className="!cht-no-underline cht-block cht-h-full"
                  to={"/recent-jobs/" + item?.slug}
                >
                  <RecentJobCard
                    id={item?.id}
                    title={item?.title}
                    body={item?.safe_summary_html}
                    category={item?.category}
                    thumbnail={item?.get_image_url}
                    date={item?.date}
                    location={item?.location}
                  />
                </Link>
              ))}
            </div>

            {safeJobs.length > 9 ? (
              <div className="cht-flex cht-justify-center cht-mt-10">
                <Button
                  to="/recent-jobs"
                  variant="primary"
                  size="md"
                >
                  See all Deliverables
                </Button>
              </div>
            ) : null}
          </div>
        </section>
      )}

      {jobLoading && <RecentJobSkeleton isTitle={true} numberOfCols={6} />}
    </>
  );
}

export default RecentJobGroup;
